export class AppInfo {
    menuFolded: boolean
}